import { Injectable } from '@angular/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AdminPanelService {

  private transactionsDetailSource = new BehaviorSubject('');
  selectedtransactionsDetailSource = this.transactionsDetailSource.asObservable();

  constructor(public http: HttpClient) { }

  // searchData(title: string, type: SearchType): Observable<any> {
  //   return this.http.get(`${this.url}?s=${encodeURI(title)}&type=${type}&apikey=${this.apiKey}`).pipe(
  //     map(results => results['Search'])
  //   );
  // }

  setSelectedTransactionsDetail(detail) {
    this.transactionsDetailSource.next(detail)
  }
  
  getReseultSetList(result_set_url) {
    return this.http.get(environment.apiUrl + result_set_url)
      .map(resdata => {
        return resdata;
      }, error => {
        return null;
      });
  }
  updateResultSet(result_set_url, data) {
    return this.http.post(environment.apiUrl + result_set_url, data)
      .map(resdata => {
        return resdata;
      }, error => {
        return null;
      });
  }
  imageupload(result_set_url, data) {
    return this.http.post(environment.apiUrl + result_set_url, data)
      .map(resdata => {
        return resdata;
      }, error => {
        return null;
      });
  }

}
